<template>
  <reference-filter-multiple-select
    label="Data Extraction Status"
    :options="options"
    :selected-values.sync="selectedModel"
  />
</template>

<script>
import ReferenceFilterMultipleSelect from './ReferenceFilterMultipleSelect';
import { AssessmentStatusFilter } from '@/enums';

const ASSESSMENT_STATUS_FILTER_TO_OPTION = {
  [AssessmentStatusFilter.NO_ASSESSMENTS]: 'No extractions',
  [AssessmentStatusFilter.AWAITING_ONE_ASSESSMENT]:
    'Awaiting an extraction',
  [AssessmentStatusFilter.AWAITING_ONE_ASSESSMENT_BY_YOU]:
    'Awaiting an extraction by you',
  [AssessmentStatusFilter.ASSESSMENTS_BY_YOU]: 'Extracted by you',
  [AssessmentStatusFilter.CONFLICTED]: 'Conflicted',
  [AssessmentStatusFilter.COMPLETE]: 'Extracted',
};

export default {
  name: 'ReferenceFilterExtractionStatus',
  components: { ReferenceFilterMultipleSelect },
  props: {
    selected: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update:selected'],
  computed: {
    selectedModel: {
      get() {
        return this.selected;
      },
      set(value) {
        this.$emit('update:selected', value);
      },
    },
    options() {
      return Object.keys(ASSESSMENT_STATUS_FILTER_TO_OPTION).map(
        (filter) => ({
          value: filter,
          label: ASSESSMENT_STATUS_FILTER_TO_OPTION[filter],
        })
      );
    },
  },
};
</script>
